import { createSlice } from '@reduxjs/toolkit'

const getInitialWishlistState = () => {
    const WishList = localStorage.getItem('wishList');
    return WishList ? JSON.parse(WishList) : [];
};

const initialState = getInitialWishlistState();

const findExistingItem = (state, id) => {
    return state.findIndex((item) => item.product_id === id);
};

export const WishlistSlice = createSlice({
    name: 'WishList',
    initialState: initialState,
    reducers: {
        addToWishList: (state, action) => {
            const existingItem = findExistingItem(state, action.payload.product_id)
            if (existingItem !== -1) return state
            state.push({ ...action.payload })
        },
        removeWishListItem: (state, action) => {
            const existingItem = findExistingItem(state, action.payload)
            if (existingItem !== -1) {
                const data = state.filter((item) => item.product_id !== action.payload)
                return data
            }
        },
    },
})

export const { addToWishList, removeWishListItem } = WishlistSlice.actions

export default WishlistSlice.reducer